import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
}

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallButton = ({ className = "", compact = false }) => {
  const [installed, setInstalled] = useState(isStandalone());
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const onInstalled = () => setInstalled(true);
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);

  if (installed) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setInstalled(true);
      deferred = null;
    } else setHelp(true);
  };

  return (
    <>
      <button onClick={install} className={`rf-btn rf-btn-sm ${className}`} data-testid="install-app-button" aria-label="Scarica app">
        <Download size={14} /> <span className={compact ? "hidden sm:inline" : ""}>Scarica app</span>
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="rounded-none" data-testid="install-help-dialog">
          <DialogHeader>
            <DialogTitle>Installa Reverse Frame</DialogTitle>
            <DialogDescription>Aggiungila alla schermata Home: si apre a schermo intero come un'app.</DialogDescription>
          </DialogHeader>
          {isIOS() ? (
            <ol className="space-y-2 text-sm">
              <li>1. Apri questa pagina in <strong>Safari</strong>.</li>
              <li className="flex items-center gap-1">2. Tocca <Share size={14} /> <strong>Condividi</strong>.</li>
              <li>3. Scegli <strong>Aggiungi alla schermata Home</strong>.</li>
            </ol>
          ) : (
            <ol className="space-y-2 text-sm">
              <li>1. Apri il menu del browser (⋮ in Chrome o Edge).</li>
              <li>2. Scegli <strong>Installa app</strong> o <strong>Aggiungi a schermata Home</strong>.</li>
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
